import endPoints from "../const/endpoints";
var getStatementPdfQueryKey = function (_a) {
    var accountId = _a.accountId, statementDate = _a.statementDate, statementInsert = _a.statementInsert;
    return [
        endPoints.statementsUrl,
        { accountId: accountId, statementDate: statementDate, statementInsert: statementInsert },
    ];
};
export default getStatementPdfQueryKey;
